import styled from 'styled-components';

interface ContainerProps {
  $isOpen: boolean;
}

export const FloatingContainer = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  user-select: none;
  position: fixed;
  bottom: 45px;
  right: 30px;
  
  span {
    display: ${(p) => (p.$isOpen ? 'inherit' : 'none')};
  }

  ${(props) =>
    props.$isOpen &&
    `height: 100%;
      .sub-button:nth-child(2) {
        transform: translateY(-80px);
      }
      .sub-button:nth-child(3) {
        transform: translateY(-140px);
      }
      .sub-button:nth-child(4) {
        transform: translateY(-200px);
      }
      .sub-button:nth-child(5) {
        transform: translateY(-260px);
      }
      .sub-button:nth-child(6) {
        transform: translateY(-320px);
      }
      `}
}

.fab {
  position: relative;
  height: 70px;
  width: 70px;
  background-color: #4ba2ff;
  border-radius: 50%;
  z-index: 3;

  &::before {
    content: " ";
    position: absolute;
    bottom: 0;
    right: 0;
    height: 35px;
    width: 35px;
    background-color: inherit;
    border-radius: 0 0 10px 0;
    z-index: -1;
  }

  .fab-content {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    border-radius: 50%;

    i {
      color: white;
      font-size: 48px;
    }
  }
}

.sub-button {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 10px;
  right: 10px;
  height: 50px;
  width: 50px;
  background-color: #4ba2ff;
  border-radius: 50%;
  transition: all 0.3s ease;
  z-index: 2;

  &:hover {
    cursor: pointer;
  }

  i {
    color: white;
    padding-top: 6px;
  }
}
`;
